import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { ILogin, ILoginWithMSOffice } from "../../vm";
import {
  isTokenExpired,
  setToken,
  setTokens,
  getQueryParams,
  parseJwt,
  passwordUpdatedDaysAgo,
  isValidPassword,
  isAdminUser,
} from "../../services/UtilService";
import { withToastContext, IToast } from "../common/ToastProvider";
import { mdiLock } from "@mdi/js";
import Icon from "@mdi/react";
import { Formik, FormikErrors } from "formik";
import {
  TextField,
  Stack,
  Text,
  PrimaryButton,
  Label,
  IIconProps,
  DefaultButton,
  Link,
} from "office-ui-fabric-react";
import { EMAIL_REGEX } from "../common/Constants";
import {
  loginToApp,
  changeExpiredPasswordForAdmin,
  changeExpiredPasswordForTeam,
  loginToAppWithMSOffice,
} from "../../services/auth/AuthService";
import "./login.css";
import {
  IPasswordChangeAlert,
  withPasswordChangeAlertContext,
} from "../change-password/PasswordChangeAlertProvider";
import PasswordPolicy from "../common/PasswordPolicy";
import LoginLeftSideImage from "../../images/login-image.png";
import LoginPageBg from "../../images/login-page-bg.png";
import { withMsal, WithMsalProps } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import ForgotPassword from "./ForgotPassword";

export interface LoginMainProps
  extends RouteComponentProps,
    IToast,
    WithMsalProps,
    IPasswordChangeAlert {}

export interface LoginMainState {
  showPasswordUpdateModel?: boolean;
  token?: string;
  refreshToken?: string;
  showForgotPasswordModel?: boolean;
}

class LoginMain extends React.Component<LoginMainProps, LoginMainState> {
  constructor(props: LoginMainProps) {
    super(props);
    this.state = {
      showPasswordUpdateModel: false,
      token: undefined,
      refreshToken: undefined,
      showForgotPasswordModel: false,
    };
  }

  componentDidMount = async () => {
    let hasTokenExpired = isTokenExpired();
    if (!hasTokenExpired) {
      this.props.history.push("/");
      await this.shouldShowPasswordChangeNotification();
    }
  };
  shouldShowPasswordChangeNotification = async () => {
    const days = await passwordUpdatedDaysAgo();
    // this.props.showPasswordChangeAlert({ isPolicyChangedUpdate: true });
    // this.props.showPasswordChangeAlert({ expireId: 14 });
    if (days !== null) {
      if (45 - days <= 15) {
        this.props.showPasswordChangeAlert({ expireId: 45 - days });
      }
    }
    if (days === null) {
      this.props.showPasswordChangeAlert({ isPolicyChangedUpdate: true });
    }
  };

  logInWithMsOfficeCreds = async () => {
    try {
      const tokenResp: any = await this.props.msalContext.instance.loginPopup(
        loginRequest
      );
      const cred: ILoginWithMSOffice = {
        email: tokenResp?.idTokenClaims?.preferred_username || "",
        uniqueId: tokenResp?.uniqueId || "",
      };
      if (cred.email && cred.uniqueId) {
        const res = await loginToAppWithMSOffice(cred);
        if (res?.success && res.data.token) {
          const tokenData = parseJwt(res.data.token);

          // Store both tokens
          if (res.data.refreshToken) {
            setTokens(res.data.token, res.data.refreshToken);
          } else {
            setToken(res.data.token); // Fallback for backward compatibility
          }

          let params: any = getQueryParams(window.location.href);
          if (params["redirect_to"]) {
            this.props.history.push(params["redirect_to"]);
          } else {
            if (
              tokenData.isAdmin === true &&
              (tokenData.role === 0 ||
                tokenData.role === 2 ||
                tokenData.role === 3 ||
                tokenData.role === 4 ||
                tokenData.role === 5)
            ) {
              this.props.history.push("/");
            } else {
              this.props.history.push(
                `/datacenters`
                //  `/datacenters/${tokenData.datacenterId}`
              );
            }
          }
        } else {
          this.props.showToast(res?.message, "error");
        }
      } else {
        this.props.showToast(
          "Something went wrong!, try again after sometimes",
          "error"
        );
      }
    } catch (error) {
      this.props.showToast("Something went wrong!", "error");
      console.log(error);
    }
  };

  officeIcon: IIconProps = { iconName: "OfficeLogo" };

  render() {
    return (
      <React.Fragment>
        <main>
          <div className="left-section">
            {/* <div className="left-img-container"> */}
            <img src={LoginLeftSideImage} alt="" className="left-img" />
            {/* </div> */}
          </div>
          <div className="right-section">
            <div className="login-logo">
              <img
                src={"/logo.png"}
                alt="STTelemedia"
                style={{ height: 40, width: 210 }}
              />
            </div>
            <div className="login-card-section">
              {this.state.showPasswordUpdateModel ? (
                <section className="card login-card">
                  <Stack horizontalAlign="start">
                    {/* <Icon path={mdiLock} size="48px" /> */}
                    <Text className="sign-in-text">Update your Password</Text>
                  </Stack>

                  <Formik
                    initialValues={{ newPassword: "", confirmPassword: "" }}
                    validate={(values) => {
                      let errors: FormikErrors<{
                        newPassword?: string;
                        confirmPassword?: string;
                      }> = {};

                      if (!values.newPassword) {
                        errors.newPassword = "Required";
                      }
                      if (
                        values.newPassword &&
                        !isValidPassword(
                          values.newPassword,
                          isAdminUser(this.state.token)
                        )
                      ) {
                        errors.newPassword = "Please enter valid password.";
                      }
                      if (!values.confirmPassword) {
                        errors.confirmPassword = "Required";
                      }
                      if (
                        values.newPassword &&
                        values.confirmPassword &&
                        values.newPassword !== values.confirmPassword
                      ) {
                        errors.confirmPassword = "Password does not match";
                      }
                      return errors;
                    }}
                    onSubmit={async (
                      values: { newPassword: string; confirmPassword: string },
                      { setSubmitting, setFieldValue }
                    ) => {
                      const tokenData = parseJwt(this.state.token);
                      let result;
                      if (tokenData.isAdmin) {
                        result = await changeExpiredPasswordForAdmin(
                          values.newPassword,
                          this.state.token
                        );
                      } else {
                        result = await changeExpiredPasswordForTeam(
                          values.newPassword,
                          this.state.token
                        );
                      }
                      if (result && result.success) {
                        if (this.state.token && this.state.refreshToken) {
                          setTokens(this.state.token, this.state.refreshToken);
                        } else if (this.state.token) {
                          setToken(this.state.token);
                        }
                        this.props.showToast(
                          "Password updated successfully",
                          "success"
                        );
                        const params: any = getQueryParams(
                          window.location.href
                        );
                        console.log(
                          "params['redirect_to']",
                          params["redirect_to"]
                        );
                        if (params["redirect_to"]) {
                          this.props.history.push(params["redirect_to"]);
                        } else {
                          this.props.history.push("/");
                        }
                      } else {
                        this.props.showToast(result.message, "error");
                      }
                      setSubmitting(false);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <Label className="login-label">New Password</Label>
                        <TextField
                          id="newPassword"
                          name="newPassword"
                          // label="New Password"
                          autoComplete="new-password"
                          type="password"
                          onChange={handleChange}
                          errorMessage={
                            errors.newPassword && touched.newPassword
                              ? errors.newPassword
                              : ""
                          }
                          onBlur={handleBlur}
                          value={values.newPassword}
                          underlined
                        />
                        {errors.newPassword &&
                          touched.newPassword &&
                          values.newPassword && (
                            <PasswordPolicy
                              password={values.newPassword}
                              isAdmin={isAdminUser(this.state.token)}
                            />
                          )}
                        <Label className="login-label">Confirm Password</Label>
                        <TextField
                          id="confirmPassword"
                          name="confirmPassword"
                          // label="Confirm Password"
                          autoComplete="confirm-password"
                          type="password"
                          onChange={handleChange}
                          errorMessage={
                            errors.confirmPassword && touched.confirmPassword
                              ? errors.confirmPassword
                              : ""
                          }
                          onBlur={handleBlur}
                          value={values.confirmPassword}
                          underlined
                        />
                        <br />

                        <PrimaryButton
                          type="submit"
                          disabled={isSubmitting}
                          className="login-btn"
                        >
                          Update Password
                        </PrimaryButton>
                      </form>
                    )}
                  </Formik>
                </section>
              ) : (
                <section className="card login-card">
                  <Stack horizontalAlign="start">
                    {/* <Icon path={mdiLock} size="48px" />
                    <Text variant="xLarge">STT Capacity Reading</Text>
                    <Text variant="xLarge">Sign In</Text> */}
                    <Text className="sign-in-text">Customer MOR SIGN IN</Text>
                  </Stack>
                  <Formik
                    initialValues={{ email: "", password: "" }}
                    validate={(values) => {
                      let errors: FormikErrors<ILogin> = {};
                      if (!values.email) {
                        errors.email = "Required";
                      } else if (!EMAIL_REGEX.test(values.email)) {
                        errors.email = "Invalid email address";
                      }
                      if (!values.password) {
                        errors.password = "Required";
                      } else if (values.password.length <= 4) {
                        errors.password = "Needs to be more than 4 characters";
                      }
                      return errors;
                    }}
                    onSubmit={async (values: ILogin, { setSubmitting }) => {
                      let res = await loginToApp(values);
                      if (res.success && res.data.token) {
                        // show toast message if has an active session
                        if (res.data.hasActiveSession) {
                          this.props.showToast(
                            "Login detected. Your previous session has been closed.",
                            "info"
                          );
                        }
                        const tokenData = parseJwt(res.data.token);
                        if (
                          tokenData &&
                          tokenData.passwordUpdatedByAdminAt != null
                        ) {
                          setSubmitting(false);
                          this.setState({
                            showPasswordUpdateModel: true,
                            token: res.data.token,
                            refreshToken: res.data.refreshToken || undefined,
                          });
                          return;
                        }

                        // Store both tokens
                        if (res.data.refreshToken) {
                          setTokens(res.data.token, res.data.refreshToken);
                        } else {
                          setToken(res.data.token); // Fallback for backward compatibility
                        }
                        // check if needs to show password change notification
                        await this.shouldShowPasswordChangeNotification();

                        let params: any = getQueryParams(window.location.href);
                        if (params["redirect_to"]) {
                          this.props.history.push(params["redirect_to"]);
                        } else {
                          if (
                            tokenData.isAdmin === true &&
                            (tokenData.role === 0 ||
                              tokenData.role === 2 ||
                              tokenData.role === 3 ||
                              tokenData.role === 4 ||
                              tokenData.role === 5)
                          ) {
                            this.props.history.push("/");
                          } else {
                            this.props.history.push(
                              `/datacenters`
                              // `/datacenters/${tokenData.datacenterId}`
                            );
                          }
                        }
                      } else {
                        this.props.showToast(res?.message, "error");
                      }
                      setSubmitting(false);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <Label className="login-label">Email Address</Label>
                        <TextField
                          id="email"
                          name="email"
                          // label="Email Address"
                          autoComplete="email"
                          autoFocus
                          onChange={handleChange}
                          errorMessage={
                            errors.email && touched.email ? errors.email : ""
                          }
                          onBlur={handleBlur}
                          value={values.email}
                          underlined
                        />
                        <Label className="login-label">Password</Label>
                        <TextField
                          id="password"
                          name="password"
                          // label="Password"
                          type="password"
                          autoComplete="current-password"
                          onChange={handleChange}
                          errorMessage={
                            errors.password && touched.password
                              ? errors.password
                              : ""
                          }
                          onBlur={handleBlur}
                          value={values.password}
                          underlined
                        />
                        <br />
                        <PrimaryButton
                          type="submit"
                          disabled={isSubmitting}
                          className="login-btn"
                        >
                          SIGN IN
                        </PrimaryButton>
                        <div style={{ display: "flex", justifyContent: "end" }}>
                          <Link
                            className="ms-Button-label forgot-password-btn"
                            disabled={isSubmitting}
                            onClick={() =>
                              this.setState({ showForgotPasswordModel: true })
                            }
                          >
                            Forgot Password?
                          </Link>
                        </div>
                        {/* <DefaultButton
                          className="office-btn"
                          onClick={this.logInWithMsOfficeCreds}
                          iconProps={this.officeIcon}
                        >
                          SIGN IN with OFFICE 365
                        </DefaultButton> */}
                      </form>
                    )}
                  </Formik>
                </section>
              )}
              <div className="login-bg-image">
                <img src={LoginPageBg} alt="login-bg" />
              </div>
            </div>
          </div>
          {this.state.showForgotPasswordModel && (
            <ForgotPassword
              onClose={() => this.setState({ showForgotPasswordModel: false })}
            />
          )}
        </main>
      </React.Fragment>
    );
  }
}

export default withMsal(
  withToastContext(withPasswordChangeAlertContext(withRouter(LoginMain)))
);
